import type { GraphQLExtensions } from '../../types/graphql';

export interface ErrorWithExtensions {
  extensions: GraphQLExtensions;
}

export const isErrorWithExtensions = (error: unknown): error is ErrorWithExtensions =>
  error !== null && Object.hasOwnProperty.call(error, 'extensions');

export const isErrorWithNonEmptyExtensions = (error: unknown): error is ErrorWithExtensions =>
  isErrorWithExtensions(error) && Object.keys(error.extensions).length > 0;
